import { AbstractProvider, Network } from 'ethers';
import rpc from './adaptive.js';
const { AdaptiveProvider } = rpc;
class DesktopReadProvider extends AbstractProvider {
  constructor(api){super(10);this.api=api;}
  async _detectNetwork(){return Network.from(10);}
  _perform(params){return this.api.rpcRead(params);}
}
export function createReadProvider(url, network){return new AdaptiveProvider([url]);}
export function createReadPool(urls, desktop){return desktop?.rpcRead ? new DesktopReadProvider(desktop) : new AdaptiveProvider(urls);}
